import React, { memo } from 'react';
import { CloseIcon } from '../../helpers/Icons';

const IndicatorPanel = ({
  theme,
  setShowIndPanel,
  groupedInds,
  indicatorControls,
}) => {
  return (
    <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: 6, zIndex: 300, background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: 14, minWidth: 230, boxShadow: '0 12px 40px rgba(0,0,0,0.6)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: theme.text }}>Indicators</span>
        <button onClick={() => setShowIndPanel(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
          <CloseIcon s={14} c={theme.textS} />
        </button>
      </div>
      {Object.entries(groupedInds).map(([group, inds]) => (
        <div key={group} style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 9, fontWeight: 700, color: theme.textM, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 5 }}>{group}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {inds.map(ind => {
              const isActive = indicatorControls.activeList.some(a => a.type === ind.id);
              return (
                <button key={ind.id} onClick={() => indicatorControls.addIndicator(ind.id)} style={{
                  padding: '4px 10px', borderRadius: 5, border: `1px solid ${isActive ? theme.primary : theme.border}`,
                  cursor: 'pointer', fontSize: 10, fontWeight: 600, fontFamily: theme.sans,
                  background: isActive ? theme.primaryGlow : theme.card2,
                  color: isActive ? theme.primaryL : theme.textS,
                }}>{ind.label}</button>
              );
            })}
          </div>
        </div>
      ))}
      {indicatorControls.activeList.length > 0 && (
        <button onClick={indicatorControls.removeAllIndicators} style={{ marginTop: 6, width: '100%', padding: '5px', borderRadius: 5, border: `1px solid ${theme.border}`, background: 'transparent', color: theme.neg, fontSize: 10, cursor: 'pointer', fontFamily: theme.sans }}>
          Remove All
        </button>
      )}
    </div>
  );
};

export default memo(IndicatorPanel);
